import EnhancementHistory from './EnhancementHistory'

export default EnhancementHistory
